import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import useDateTimeFormat from 'utils/hooks/useDateTimeFormat'
import { DATE_FORMAT } from '../constants'

const DateColumnFramework = ({ value, colDef }) => {
  const {
    cellRendererParams: { showTime }
  } = colDef

  useTranslation() // Update moment dates that depend on locale (for example 1 January 2000)

  const { dateFormat, timeFormat } = useDateTimeFormat()
  if (!value) return null
  // const momentValue = moment(value, DATE_FORMAT).utc(true).local() // utc(true) increases the time by one hour
  const momentValue = moment(value, DATE_FORMAT).local()

  return (
    <div className='date-column'>
      <span className='date-span'>{momentValue.format(dateFormat.value)}</span>
      {showTime && (
        <span className='time-span'>
          {momentValue.format(timeFormat.value)}
        </span>
      )}
    </div>
  )
}

export default DateColumnFramework
